import { FC, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import AttivaCard from "../../../../components/card/AttivaCard";
import { Loader } from "../../../../components/loader/SpinnerLogo";
import useFetch from "../../../../hooks/useFetch";
import useHandleErrors from "../../../../hooks/useHandleErrors";
import PageHeader from "../../../../layout/shared/page-header";
import { menuRoutes } from "../../../../router/menu";
import { IncidenceTypeService } from "../../../../services/incidence-type/incidenceTypeService";
import { IncidenceType } from "../../../../type/entities/incidence-type";
import IncidenceTypeForm from "../IncidenceTypeForm";


const IncidenceTypeEdit: FC = () => {

    const { id = "" } = useParams<{ id: string }>();
    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new IncidenceTypeService();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [data, loading] = useFetch(useCallback(async () => {
        const response = await service.getIncidenceTypeById(id as string);
        return response.getResponseData() as IncidenceType;
    }, [id]));

    const pageHeader = {
        title: `Editar Tipo de incidencia ( ${data?.name} )`,
        breadcrumb: [
            { name: 'Ventas' },
            { name: 'Gestión de incidencias' },
            { name: 'Tipos de Incidencia', href: menuRoutes.incidenceTypes.path },
            { name: 'Editar' },
        ],
    };

    const handleSubmit = async (values: any) => {
        try {
            const response = (await service.editIncidenceType(values)).getResponseData();
            if (response.success) {
                navigate(-1);
                toast.success("Tipo de incidencia editado correctamente");
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error("Error al editar el tipo de incidencia");
        }
    };

    if (loading) return <Loader />;

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title="Datos Principales">
                {(data !== null && data !== undefined) && <IncidenceTypeForm data={data} submit={handleSubmit} isLoading={isLoading} />}
            </AttivaCard>
        </>
    );
}

export default IncidenceTypeEdit;